export const Button = {
    baseStyle() {
        return {};
    },
    variants: {},
    sizes: {},
    defaultProps: {},
};
